import {
  BlockTypeSelect,
  BoldItalicUnderlineToggles,
  CreateLink,
  directivesPlugin,
  headingsPlugin,
  linkDialogPlugin,
  linkPlugin,
  listsPlugin,
  ListsToggle,
  thematicBreakPlugin,
  toolbarPlugin,
} from '@mdxeditor/editor'
import { CreateText, TextDirectiveDescriptor } from './textPlugins'

export function parseMarkdown(input = '') {
  return input
    .replace(/\{\{content\|(.*?)\}\}/g, ':content{id=$1}')
    .replace(/<br>/gm, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}

export function encodeMarkdown(input = '') {
  return input.replace(/:content{#([^"]+)}/g, '{{content|$1}}')
}

export function makePlugins(readOnly?: boolean, hideBlockTypes?: boolean, tagText?: boolean) {
  let plugins = [
    headingsPlugin(),
    linkDialogPlugin(),
    linkPlugin(),
    listsPlugin(),
    thematicBreakPlugin(),
  ]

  if (tagText) {
    plugins.push(
      directivesPlugin({
        directiveDescriptors: [TextDirectiveDescriptor],
      })
    )
  }

  if (!readOnly) {
    plugins.push(
      toolbarPlugin({
        toolbarContents: () => (
          <>
            {!hideBlockTypes && <BlockTypeSelect />}
            <BoldItalicUnderlineToggles />
            <ListsToggle options={['bullet', 'number']} />
            <CreateLink />
            {tagText && <CreateText />}
          </>
        ),
      })
    )
  }

  return plugins
}
